export const tangoLogo = "/tango-logo.png";
